import React from 'react'
import utils from './utils'
import { images } from '../../../../services/assets.services'

function getLevelLayout(width, height, settings, quantities, answer, onEnter, onFail) {
    return getLayout(width, height, settings, quantities, answer, onEnter, onFail)
}

function getLayout(gameContainerWidth, gameContainerHeight, settings, quantities, onEnter, onFail) {
    let scale = 0
    let gridBgWidth = 400
    let gridBgHeight = 400
    let cellWidth = 40
    let cellHeight = 36.4
    if (gridBgWidth / gridBgHeight > gameContainerWidth / gameContainerHeight) {
        scale = gameContainerWidth / gridBgWidth
    } else {
        scale = gameContainerHeight / gridBgHeight
    }

    let questionCellX = (cellWidth) * ((quantities.value_1 % 10 === 0 ? 10 : 0) + quantities.value_1 % 10 - 1)
    let questionCellY = (cellHeight) * (Math.ceil(quantities.value_1 / 10))
    let answerCellX = (cellWidth) * ((quantities.value_2 % 10 === 0 ? 10 : 0) + quantities.value_2 % 10 - 1)
    let answerCellY = (cellHeight) * (Math.ceil(quantities.value_2 / 10))
    return (
        <svg
            height={gameContainerHeight}
            width={gameContainerWidth}

        >
            <g transform={`translate(${(gameContainerWidth - gridBgWidth * scale) / 2}, ${(gameContainerHeight - gridBgHeight * scale) / 2}), scale(${scale})`}>
                <g transform={`translate(${questionCellX}, ${questionCellY})`}>
                    {
                        <image
                            width={cellWidth}
                            height={cellHeight}
                            xlinkHref={images.svg['grid-cell']}

                        />
                    }
                </g>

                <image
                    width={gridBgWidth}
                    height={gridBgHeight}
                    xlinkHref={images.svg['grid-numbers']}

                />

                <rect
                    x={0}
                    y={0}
                    width={gridBgWidth}
                    height={gridBgHeight}
                    fill='transparent'
                    stroke='none'
                    onClick={() => onFail()}
                />

                <rect
                    x={answerCellX}
                    y={answerCellY}
                    width={cellWidth}
                    height={cellHeight}
                    fill='transparent'
                    stroke='none'
                    onClick={() => onEnter()}
                />
            </g>
        </svg>
    )
}

export default {
    getLevelLayout,
}


// WEBPACK FOOTER //
// ./src/components/game/levels/utils/hundredSquareTap.utils.js